import { http } from "Utils/http";
import { store } from 'Store';
import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import DatatableBase from "Components/Datatable/DatatableBase";
import { TextButton, IconTextButton } from "Components/Button";
import { Col } from "react-bootstrap";
import CreateWebServiceAccountPopup from "../Create/Popup/CreatWebServiceAccountPopup";
import { isInObject } from "Utils/utilityFunctions";
import { generateWsaPwdHisRpt } from "../WebServiceAxiosFuncs";
import { ERROR_MESSAGES } from "Utils/constants";
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import { ICONS } from "Utils/icons";

const ListWebServiceAccount = () => {

  const dispatch = useDispatch();
  const listWebServiceAccounts = "Search by Organization Name and ID";
  const loginState = store.getState().loginInfo;
  const [reloadListWebServiceAccount, setReloadListWebServiceAccount] = useState(false);
  const [listWebServiceAccountSortColumn, setListWebServiceAccountSortColumn] = useState({
    sortField: "psoId",
    sortDirection: "asc"
  });
  const [showPopup, setShowPopup] = useState(false);
  const [filter, setFilter] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const location = useLocation();

  // Date format: mm/dd/yyyy hh: mm
  const handleDateFormat = (time) => {
    if (time == null) {
      return;
    }

    let date = new Date(time);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    return (
      <div>
        {month < 10 ? "0" + month : month}/
        {day < 10 ? "0" + day : day}/
        {year + " "}
      </div>
    )
  }

  const getData = async (filter) => {

    setFilter(filter);

    var call = {
      ...filter
    }
    //console.log("call get web service account list");
    var url = '/api/organization/ws-account/list';

    return http.post(url, call, {
      headers: {
        "Authorization": "Bearer " + loginState.token
      }
    });
  }

  const getListCols = (selectedList, sortingInfo) => {
    const listColumns = [];

    const wsAccountInfoState = function ({ rowName }) {
      //console.log("print out wsAccountInfoState", rowName);
      return {
        wsAccountInfo: rowName,
        filter: filter
      }
    }

    listColumns.push(Datatable_Column({ name: "Organization ID", columnName: "psoId", selectedRows: selectedList, sortable: true, sortFieldNum: 0, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "Organization Name", columnName: "psoName", selectedRows: selectedList, sortable: true, sortFieldNum: 1, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "PW Change Date", columnName: "passwordChangeDate", selectedRows: selectedList, sortable: true, sortFieldNum: 2, formatFunction: handleDateFormat, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "PW Expire Date", columnName: "passwordExpireDate", selectedRows: selectedList, sortable: true, sortFieldNum: 3, formatFunction: handleDateFormat, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "Account Status", columnName: "acctStatus", selectedRows: selectedList, sortable: true, sortFieldNum: 4, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "Edit", columnName: "edit", selectedRows: selectedList, sortable: false, sortFieldNum: 5, isLink: true, linkData: { title: "", pathname: "/manage/editWebServiceAccount", text: "Edit", state: wsAccountInfoState }, sortingInfo: sortingInfo }));

    return listColumns;
  }

  const handleClose = () => {
    setShowPopup(false);
  }

  const handleCreateWSAccount = () => {
    //console.log("handleCreateWSAccount", showPopup);
    setRefresh(!refresh);
    setShowPopup(true);
  }

  useEffect(() => {
    var passedData = location.state;
    //console.log("FILTER", passedData);

    if (isInObject("filter", passedData)) {
      //console.log("setFilter");
      setFilter(passedData.filter);
    }
    else {
      setFilter({
        startIndex: 0,
        entryPerPage: 10,
        sortingColumn: listWebServiceAccountSortColumn.sortField,
        sortingOrder: listWebServiceAccountSortColumn.sortDirection,
        searchTerm: ""
      });
    }
  }, []);

  const handleFileDownload = async () => {

    const res = await generateWsaPwdHisRpt("Bearer " + loginState.token).catch((error) => {
      //console.log("error handleFileDownload()", error);
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
        error: error
      });
    });
    //console.log("after handleFileDownload", res);

    if (res?.status?.code === 1) {
      // get filename from the res content-disposition
      const fileName = res.data.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');
      //console.log("after handleFileDownload filename", fileName);
      let url = window.URL.createObjectURL(res.data.data);
      let a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a); // append the element to the dom
      a.click();
      a.remove(); // afterwards, remove the element  
    } else {
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
        error: res.data?.status?.text
      });
    }
  }

  return (
    <>
      {showPopup ?
        <CreateWebServiceAccountPopup show={showPopup} handleClose={handleClose} refresh={refresh} setReloadListWebServiceAccount={setReloadListWebServiceAccount} />
        : null
      }
      {filter != null ?
        <DatatableBase
          tableClassName="wsAccountTable"
          reload={reloadListWebServiceAccount}
          setReload={setReloadListWebServiceAccount}
          getData={getData}
          getListCols={getListCols}
          filter={filter}
          setFilter={setFilter}
          //setSelected={setSelected}
          //hasSelectableRows={true}
          searchFieldText={listWebServiceAccounts}
          datatableHeader={null}
          datatableDescription={null}
          sortingColumn={listWebServiceAccountSortColumn.sortField}
          sortingOrder={listWebServiceAccountSortColumn.sortDirection}
        >
          {
            <>
              <Col className="d-flex justify-content-end gap-4">
                <TextButton
                  className="ms-auto"
                  onClick={handleCreateWSAccount}
                  variant="normal"
                  content={"Create New Account"}
                />
                <IconTextButton
                  className="reverse"
                  icon={ICONS.download}
                  onClick={handleFileDownload}
                  variant="normal"
                  content={"Password History Report"}
                />
              </Col>
            </>
          }
        </DatatableBase> : null}
    </>
  )

}

export default ListWebServiceAccount;